/**
 * Created by 唐亦慧 on 2018/2/6.
 * zhouyanping 2021年4月14日16:10:42 update
 * 1、隐藏价格，销量、热销、新品排序信息。
 * 2、新增商品系列展示。
 */
import React from 'react';
import Reflux from 'reflux';
import {
    hashHistory,
    withRouter,
} from 'react-router';
import {
    Layout,
    Badge,
    Menu,
    Input,
    Radio,
    Avatar,
    Carousel,
    Breadcrumb,
    Pagination,
    message,
    Spin,
} from 'antd';
import '../mall-menus.css';
import '../mallApp.css';
import {
    productActions,
    productStore,
} from './store';
import {
    openNotice,
    returnFloat,
} from '../../utils/index';
import {
    isShowInventory,
} from '../../service/mall';
import {
    commodityModelSelectionList,
} from '../../service/merchandise';
import {getShoppingCarList} from '../../service/shoppingCar';
import {
    getProductCategory,
} from '../../service/product';
import {
    bannerAdvertList,
} from '../../service/carousel';
import {
    sKeylist,
} from '../../service/dictionary/dataitem';

const {Header, Content} = Layout;
import config from '../../utils/config';
import {getOrderList, getOrderList2} from '../../service/order';
import zxLogo from '../../assets/images/zx_logo.png';

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class MallHome extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(productStore);
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            seriesOptions: [],  // 分类按钮
            seriesStyle: {background: '#ffffff', height: 'auto'}, // 商品系列样式
            defaultSelectedKeys: [],
            maxKey: [],
            chooseWord: '',//面包屑
            secondWord: '',
            selectKeys: [],
            dataSource: [],
            dataLength: 0,
            loading: false,
            secondFlag: false, //二级菜单是否显示
            mainMenu: [],
            minMenu: [],
            zeroAdd: true,
            lables: ['', '新品', '推荐', '热销', '爆款'],//活动
            condition: {
                selectIndex: '0',
                data: [
                    /*{
                      'code': 'view_count',
                      'sort': 0,
                      'text': '综合',
                    },*/
                    {
                        'code': 'isHot',
                        'sort': 0,
                        'text': '热销',
                    },
                    {
                        'code': 'isNew',
                        'sort': 0,
                        'text': '新品',
                    },
                    /*{
                      'code': 'show_price',
                      'sort': 0,
                      'text': '价格',
                    },*/
                ],
            },
            isShow: true, //是否显示库存
            maxKeyValue: this.store.state.maxKeyValue,
            minKeyValue: this.store.state.minKeyValue,
            searchObj: {
                name: '',
                proBigType: '',
                proMiddleType: '',
                proDetailType: '',
                isHot: '1',
                isNew: '1',
                p: 1,
                s: 10,
                seriesCode: '' // 商品系列
            },
            mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px',
            cartCount: 0, //购物车
            keyword: this.store.state.searchMallData.name, //关键字
            orderLength: 0,
            orderSearchObj: {
                code: '',
                productCode: '',
                orderStatus: '',
                orderType: '',
                gatherRealityAddress: '',
                channelCode: this.channelData.split('|')[1] || '',
                getProCode: '',
                customerOrderCode: '',
                startCreatedDate: '',
                endCreatedDate: '',
                buyCompanyId: '',
                remark: '',
                specialOfferCode: '',
                s: 10,
                p: 1,
            },
            messageLength: 0,
            carouselList: [],
        };
        this.getList = this.getList.bind(this);
        this.getMainMenu = this.getMainMenu.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.mouseEnter = this.mouseEnter.bind(this);
        this.getMinKey = this.getMinKey.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
        this.goView = this.goView.bind(this);
        this.resize = this.resize.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.getData = this.getData.bind(this);
        this.conditionChange = this.conditionChange.bind(this);
        this.getCartCount = this.getCartCount.bind(this);
        this.isShowInventory = this.isShowInventory.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        const {searchObj, maxKeyValue, minKeyValue} = this.state;
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'mallCommon' && path[2] === 'productDetail') { //当下一个路由是详情页时，将useStore的值设为true
            productActions.useStoreChange(true);
            productActions.paramChange(searchObj);
            productActions.changeValue('maxKeyValue', maxKeyValue);
            productActions.changeValue('minKeyValue', minKeyValue);
        } else {
            productActions.useStoreChange(false);
            productActions.paramChange({});
            productActions.changeValue('maxKeyValue', '');
            productActions.changeValue('minKeyValue', '');
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                searchObj: data.storeData,
            });
        }
    }

    // 查询分类信息
    onChangeSeries(event) {
        this.setState({
            searchObj: {...this.state.searchObj, ...{seriesCode: event.target.value}, p: 1}
        }, () => {
            // 查询商品
            this.getData();
        })
    }

    componentDidMount() {
        window.onresize = this.resize;
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.getMainMenu();
        this.getCartCount();
        // this.isShowInventory();
        if (this.userData.second) {
            // trans/order/list
            getOrderList2({p: 1, s: 10}).then(result => {
                if (result && result.code == 200) {
                    this.setState({
                        'orderLength': result.total,
                    });
                } else {
                    openNotice('error', '数据获取失败', '');
                }
            })
        } else {
            getOrderList(this.state.orderSearchObj).then((result) => {
                if (result && result.code == 200) {
                    this.setState({
                        'orderLength': result.total,
                    });
                } else {
                    openNotice('error', '数据获取失败', '');
                }
            });
        }
        bannerAdvertList().then(res => {
            if (res.status) {
                let data = res.data || {};
                let picInfo = JSON.parse(data.picInfo || '[]');
                picInfo = picInfo.map(x => ({
                    ...x,
                    linkAddr: /^http(s)?:\/\/\S+/.test(x.linkAddr) ? x.linkAddr : '',
                    url: x.purl ? `${config.server}${x.purl}` : ''
                })).filter(x => !!x.url);
                this.setState({
                    carouselList: picInfo
                })
            }
        })
        sKeylist({sKey: 'commodity_series'}).then(res => {
            if (res.status) {
                let list = (res.data || []).map(x => ({
                    value: x.sKey,
                    text: x.name,
                    url: x.filePath ? `${config.server}/${x.filePath}` : '',
                }))

                this.setState({
                    seriesOptions: list,
                    // seriesStyle:{...this.state.seriesStyle, minWidth:(list.length * 179)+'px'}
                });
            }
        });
    }

    isShowInventory() {
        isShowInventory().then((result) => {
            if (result && result.status) {//{show_inventory: "N", allow_reservation: "Y"}
                var isShowInventory = result.data;
                if (isShowInventory.show_inventory && isShowInventory.show_inventory == 'N') {
                    this.setState({
                        isShow: false,
                    });
                } else {
                    this.setState({
                        isShow: true,
                    });
                }
                if (isShowInventory.allow_reservation && isShowInventory.allow_reservation == 'N') {
                    this.setState({
                        zeroAdd: false,
                    });
                } else {
                    this.setState({
                        zeroAdd: true,
                    });
                }
            } else {
                message.error(result.message);
            }
        });
    }

    resize() {
        if (this.state.mainMenu.length > 0) {
            if ((window.document.body.clientHeight - 64 - 128 - 132) > (this.state.mainMenu.length * 42)) {
                this.setState({mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px'});
            } else {
                this.setState({mainHeight: this.state.mainMenu.length * 42 + (100 - 0) + 'px'});
            }
        } else {
            this.setState({mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px'});
        }
    }

    //获取购物车商品数量
    getCartCount() {
        const params = {
            userId: this.userData.id,
            name: '',
            category: [],
            active: '',
            s: 10,
            p: 1,
            channelCode: this.channelData.split('|')[1] || ''
        };
        getShoppingCarList(params).then((result) => {
            if (result.status && result.data) {
                this.setState({
                    cartCount: result.data.count || null,
                });
            } else {
                if (!result.status) message.error(result.message);
            }
        });
    }

    //获取菜单
    getMainMenu() {
        var self = this;
        const {condition, maxKeyValue, minKeyValue} = this.state;
        var categoryId = '';
        var dKey = []; //defaultSelectedKeys
        var xKey = []; //maxKey
        var cWord = '';	 //chooseWord
        var sWord = ''; //secondWord
        var sKey = []; //selectKeys
        // getProductCategory
        getProductCategory().then((res) => {
            if (res.status) {
                const filterEmpty = (list, codePath) => list.map(x => {
                    let key = x.code; // 实际使用的业务数据是 code；
                    if (x.children && x.children.length) {
                        return {
                            ...x,
                            key: key, // 使用实际业务数据重新给 key 赋值
                            value: key, // 使用实际业务数据重新给 value 赋值
                            isLeaf: false,
                            disableCheckbox: !x.categoryId,
                            codePath: [...codePath, x.code],
                            children: filterEmpty(x.children, [...codePath, x.code]),
                        };
                    }
                    return {
                        ...x,
                        key: key, // 使用实际业务数据重新给 key 赋值
                        value: key, // 使用实际业务数据重新给 value 赋值
                        isLeaf: true,
                        disableCheckbox: !x.categoryId,
                        codePath: [...codePath, x.code],
                        children: undefined,
                    };
                });
                const tree = filterEmpty(res.data || [], []);
                this.setState({
                    mainMenu: tree,
                });
                if ((window.document.body.clientHeight - 64 - 128 - 132) > (res.data.length * 42)) {
                    this.setState({mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px'});
                } else {
                    this.setState({mainHeight: res.data.length * 42 + (100 - 0) + 'px'});
                }
                if (tree.length > 0) {
                    if (!maxKeyValue && !minKeyValue) {
                        categoryId = '';
                        cWord = '';
                        sWord = '';
                        dKey = [];
                        xKey = [];
                        sKey = [];
                    } else {
                        var findXKey = (tree.findIndex((x) => x.value == maxKeyValue)).toString();
                        xKey.splice(0, 1, findXKey);
                        dKey.splice(0, 1, findXKey);
                        sKey.splice(0, 1, findXKey);
                        cWord = tree[findXKey].label;
                        if (!minKeyValue) {
                            categoryId = maxKeyValue;
                        } else {
                            categoryId = minKeyValue;
                            var findXKey2 = (tree[findXKey].children.findIndex((x) => x.value == minKeyValue)).toString();
                            sWord = tree[findXKey].children[findXKey2].label;
                        }
                    }
                    let conditionData = this.state.condition.data.map(x => ({...x, sort: 0}))
                    this.setState({
                        maxKey: xKey,
                        defaultSelectedKeys: dKey,
                        selectKeys: sKey,
                        chooseWord: cWord,
                        secondWord: sWord,
                        condition: {
                            ...this.state.condition,
                            selectIndex: '0',
                            data: conditionData,
                        },
                        searchObj: {
                            ...this.state.searchObj,
                            name: '',
                            proBigType: '',
                            isHot: '',
                            isNew: '',
                            p: 1,
                        },
                    }, function () {
                        self.getData();
                    });
                }
            } else {
                message.error(res.message);
            }
        });
    }

    //获取数据
    getData() {
        const {searchObj} = this.state;
        this.setState({loading: true});
        commodityModelSelectionList(searchObj).then((result) => {
            this.setState({loading: false});
            if (result.status) {
                this.setState({
                    dataSource: (result.data || []).map(x => ({
                        ...x,
                        picPreviewUrl: `${config.server}${x.picPreviewUrl}`
                    })),
                    dataLength: result.total || 0,
                });
            } else {
                message.error(result.message);
            }
        });
    }

    /*全部商品*/
    clickGetAll() {
        var self = this;
        var conData2 = this.state.condition.data;
        for (var u = 0; u < conData2.length; u++) {
            conData2[u].sort = 0;
        }
        this.setState({
            maxKey: [],
            defaultSelectedKeys: [],
            selectKeys: [],
            chooseWord: '',
            secondWord: '',
            maxKeyValue: '',
            minKeyValue: '',
            condition: {
                ...this.state.condition,
                selectIndex: '0',
                data: conData2,
            },
            searchObj: {
                ...this.state.searchObj,
                // categoryId: '',
                name: '',
                proBigType: '',
                proMiddleType: '',
                proDetailType: '',
                isHot: '',
                isNew: '',
                p: 1,
            },
        }, function () {
            self.getData();
        });
    }

    //一级菜单改变
    getList({item, key, keyPath}) {
        const [code, index] = key.split('_');
        const {mainMenu} = this.state;
        var conData3 = this.state.condition.data;
        for (var q = 0; q < conData3.length; q++) {
            conData3[q].sort = 0;
        }
        var self = this;
        this.setState({
            secondFlag: false,
            maxKeyValue: mainMenu[index].value,
            minKeyValue: '',
            chooseWord: mainMenu[index].label,
            secondWord: '',
            maxKey: [index],
            selectKeys: [index],
            condition: {
                ...this.state.condition,
                selectIndex: '0',
                data: conData3,
            },
            searchObj: {
                ...this.state.searchObj,
                name: '',
                proBigType: mainMenu[index].value,
                proMiddleType: '',
                proDetailType: '',
                isHot: '',
                isNew: '',
                p: 1,
            },
        }, function () {
            self.getData();
        });
    }

    //二级菜单改变
    getMinKey({item, key, keyPath}) {
        const [code, index] = key.split('_');
        const {mainMenu, minMenu, maxKey} = this.state;
        var self = this;
        this.setState({
            secondFlag: false,
            selectKeys: maxKey,
            maxKeyValue: mainMenu[maxKey[0]].value,
            chooseWord: mainMenu[maxKey[0]].label,
            minKeyValue: minMenu[index].value,
            secondWord: minMenu[index].label,
            condition: {
                ...this.state.condition,
                selectIndex: '0',
                data: this.state.condition.data.map(x => ({...x, sort: 0})),
            },
            searchObj: {
                ...this.state.searchObj,
                proMiddleType: code,
                isHot: '',
                isNew: '',
                p: 1,
            },
        }, function () {
            self.getData();
        });
    }

    //顶部菜单改变
    conditionChange({item, key, keyPath}) {
        const {condition, searchObj} = this.state;
        if (key == condition.selectIndex) {
            condition.data[key].sort = condition.data[key].sort ? 0 : 1
        } else {
            condition.data = condition.data.map((x, index) => ({
                ...x,
                sort: index == key ? 1 : 0
            }))
        }
        let tmp = {};
        condition.data.forEach(x => {
            tmp[x.code] = x.sort;
        })
        this.setState({
            secondFlag: false,
            condition: {
                ...condition,
                selectIndex: key,
            },
            searchObj: {
                ...searchObj,
                ...tmp,
                p: 1,
            },
        }, () => {
            this.getData();
        });
    }

    pageChange(page, pageSize) {
        var self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: page,
            },
        }, () => {
            self.getData();
        });
    }

    //鼠标进入一级菜单
    mouseEnter(e) {
        const [code, index] = e.key.split('_');
        const firstMenu = {children: [], key: '', label: '全部', leaf: true, type: null, value: ''};
        let minMenu = [...this.state.mainMenu[index].children]
        minMenu.unshift(firstMenu);
        this.setState({
            secondFlag: true,
            maxKey: [index],
            selectKeys: [index],
            maxKeyValue: code,
            minMenu,
        });
    }

    mouseLeave(e) {
        this.setState({
            secondFlag: false,
        });
    }

    //页面跳转
    goView(url) {
        hashHistory.push(url);
    }

    toggleHome() {
        let url = window.location.href;
        if (/dms-pc/.test(url)) {
            window.location.href = url.split('dms-pc')[0] + 'dms-pc/#/home';
        } else {
            window.location.href = '/#/home';
        }
    }

    //关键字改变
    keywordChange(e) {
        this.setState({
            keyword: e.target.value,
        });
    }

    toGetMall() {
        if (this.state.keyword) {
            var newSearch = {
                ...this.store.state.searchMallData,
                name: this.state.keyword,
                p: 1,
                s: 10,
                proBigType: '',
                proMiddleType: '',
                proDetailType: '',
                seriesCode: '',
                isHot: '1',
                isNew: '1',
            };
            productActions.searchChange(newSearch);
            hashHistory.push('/mallSearch');
        } else {
            message.info('请输入商品名称');
        }
    }

    jumpZx() {
        window.open("https://zx.tengen.com.cn");
    }

    render() {
        const {
            zeroAdd, isShow, loading, cartCount, lables, searchObj,
            selectKeys, dataLength, dataSource, condition, mainMenu, maxKey,
            minMenu, defaultSelectedKeys, chooseWord, secondWord, secondFlag,
            orderLength, messageLength, carouselList, seriesOptions, seriesStyle
        } = this.state;
        const contentBox = {
            borderTop: '2px solid #65aca6',
            padding: '0 90px 50px 90px',
            background: '#fff',
            position: 'relative'
        }
        return <div>
            <Layout style={{background: '#fff'}}>
                <Header className='home-header'>
                    {/*<div style={{ cursor: 'pointer' }} onClick={this.clickGetAll.bind(this)} className="all-goods">
            全部商品分类
          </div>*/}
                    <div className="mall-search">
                        <Input placeholder='请输入商品名称' onChange={this.keywordChange.bind(this)} type="text"
                               onPressEnter={() => this.toGetMall()}
                               defaultValue={this.state.keyword}/>
                        <button onClick={this.toGetMall.bind(this)}>搜 索</button>
                    </div>
                    <img src={zxLogo} onClick={this.jumpZx.bind(this)} width={130} style={{position:"absolute",paddingTop:"17px"}}/>

                    <div className='mall-cart' onClick={this.goView.bind(this, '/mallCart')}>
                        <i className='comIcon dmsCart'></i>
                        <span className='cart-word'>我的购物车</span>
                        <Badge count={cartCount}>
                            <span>&emsp;</span>
                        </Badge>
                    </div>


                    <div className="header-left" onClick={() => hashHistory.push('/mallHome')}>
                        <i style={{fontSize: '18px'}} className="dmsIcon dmsHome"></i>
                        <span style={{paddingLeft: '12px'}}>首页</span>
                    </div>
                    {/*<div className="header-right">
            <div className='mall-nav' onClick={() => this.userData.second ? hashHistory.push('/thingsOrder') : hashHistory.push('/order')}>
              <i className='nav-word comIcon orderIcon'></i>
              {
                orderLength > 99 ?
                  <span className='nav-dot-more'>99<sup>+</sup></span>
                  :
                  <span className='nav-dot'>{orderLength}</span>
              }
            </div>
            <div className='mall-nav'
                 onClick={() => hashHistory.push('/mallCommon/userCenter/userInfo')}>
              <sapn className='nav-word comIcon userIcon'></sapn>
            </div>
          </div>*/}

                </Header>

                {/*{!!carouselList.length && <div className="carousel-box">
          <Carousel>
            {
              carouselList.map((x, index) => {
                if(x.linkAddr) {
                  return <a key={index} className="carousel-item" href={x.linkAddr}>
                    <img src={x.url} />
                  </a>
                }
                return <div key={index} className="carousel-item"><img src={x.url} /></div>
              })
            }
          </Carousel>
        </div>}*/}
                <Layout
                    style={contentBox}>
                    {/*暂时隐藏导航栏*/}
                    {/*<div style={{ cursor: 'pointer' }} onClick={this.clickGetAll.bind(this)} className="all-goods">
           全部商品分类
           </div>
            <div id='menu' className='mall-menu' onMouseLeave={this.mouseLeave}>
            {
              secondFlag && <div className="second-menu">
                <Menu mode="horizontal"
                      theme='second'
                      selectedKeys={[this.state.minKeyValue ? `${this.state.minKeyValue}` : '']}
                      onClick={this.getMinKey}>
                  {
                    minMenu.map((min, key) => {
                      return <Menu.Item key={`${min.code}_${key}`}>
                        <span>{min.label}</span>
                      </Menu.Item>;
                    })
                  }
                </Menu>
              </div>
            }
            <Menu theme="mall"
                  mode="inline"
                  onClick={this.getList}
                  selectedKeys={selectKeys}>
              {
                mainMenu.map((main, key) => {
                  return <Menu.Item className={key == maxKey[0] && secondFlag ? 'menu-active' : ''}
                                    key={`${main.code}_${key}`}
                                    onMouseEnter={this.mouseEnter}>
                    <span>{main.label}</span>
                  </Menu.Item>;
                })
              }
            </Menu>
          </div>*/}
                    <Content style={{paddingLeft: '34px', minHeight: this.state.mainHeight, background: '#fff'}}>
                        <div className='content-title'>
                            <Breadcrumb separator=">">
                                {/*<Breadcrumb.Item>首页</Breadcrumb.Item>*/}
                                <Breadcrumb.Item>{chooseWord}</Breadcrumb.Item>
                                <Breadcrumb.Item>{secondWord}</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>

                        <div className='content-menu' style={{height: 'initial', marginTop: '10px'}}>
                            {/* <Menu mode="horizontal"
                    theme='filter'
                    onClick={this.conditionChange}
                    selectedKeys={[condition.selectIndex]}>
                {
                  condition.data.map((x, index) => {
                    return <Menu.Item key={`${index}`}>
                      <span>{x.text}</span>
                      &emsp;
                      {index == condition.selectIndex && <i className={`comIcon${x.sort == 0 ? ' arrowDown' : ' arrowUp'}`}></i>}
                    </Menu.Item>;
                  })
                }
              </Menu> */}

                            <div className="dms-radio-img-box">
                                <RadioGroup onChange={this.onChangeSeries.bind(this)} style={seriesStyle}>
                                    {
                                        seriesOptions.map(x => (
                                            <RadioButton key={x.value} className="dms-radio-img" value={x.value}>
                                                <Avatar className="ant-avatar-max" src={x.url}/>
                                                <p>{x.text}</p>
                                            </RadioButton>
                                        ))
                                    }
                                </RadioGroup>
                            </div>

                        </div>
                        <Spin spinning={loading}>
                            {
                                dataSource.length > 0 &&
                                <div className='goods-list clear'>
                                    {
                                        dataSource.map((item, key) => {
                                            return <dl key={key}>
                                                <dt onClick={this.goView.bind(this, `/mallCommon/productDetail/${item.id}/${item.productId}/select`)}>
                                                    <img
                                                        src={item.picPreviewUrl ? item.picPreviewUrl : require('../../assets/images/product-default.png')}
                                                        onError={e => {
                                                            e.target.src = require('../../assets/images/product-default.png')
                                                        }}
                                                        alt="图片加载失败"/>
                                                    {
                                                        item.minPrice > item.minPromotionPrice && item.promotionCount > 0 &&
                                                        <div></div>
                                                    }
                                                    {
                                                        item.minPrice > item.minPromotionPrice && item.promotionCount > 0 &&
                                                        <p>促销</p>
                                                    }
                                                    {
                                                        item.inventory == 0 && !zeroAdd &&
                                                        <i className="dmsIcon dmsSoldOut"></i>
                                                    }
                                                </dt>
                                                <dd>
                                                    <div
                                                        onClick={this.goView.bind(this, `/mallCommon/productDetail/${item.id}/${item.productId}`)}>
                                                        {
                                                            !!item.labeling &&
                                                            <span style={{
                                                                display: 'inline-block',
                                                                fontSize: '12px',
                                                                height: '17px',
                                                                lineHeight: '14px',
                                                                padding: '0 3px',
                                                                border: '1px solid #d61518',
                                                                color: '#d61518',
                                                                borderRadius: '3px',
                                                                marginRight: '5px',
                                                            }}>{lables[item.labeling]}</span>
                                                        }
                                                        {item.name}
                                                    </div>
                                                    <p>
                                                        {/* <span>{returnFloat(item.showPrice)}</span>
                            {
                              isShow &&
                              <span style={{
                                float: 'right',
                                fontSize: '12px',
                              }}>总销量 {item.totalSalesNum}</span>
                            } */}
                                                        {
                                                            (!isShow && !zeroAdd) && item.inventory > 0 &&
                                                            <span style={{float: 'right', fontSize: '12px'}}>有货</span>
                                                        }
                                                        {
                                                            (!isShow && !zeroAdd) && !(item.inventory > 0) &&
                                                            <span style={{float: 'right', fontSize: '12px'}}>缺货</span>
                                                        }
                                                    </p>
                                                </dd>
                                            </dl>;
                                        })
                                    }
                                </div>
                            }
                            {
                                dataSource.length > 0 &&
                                <div className="mall-page">
                                    <Pagination
                                        showQuickJumper
                                        showTotal={total => `共 ${total} 条`}
                                        defaultCurrent={1}
                                        current={searchObj.p}
                                        total={dataLength}
                                        onChange={this.pageChange}
                                        defaultPageSize={searchObj.s}
                                    />
                                </div>
                            }
                            {
                                dataSource.length == 0 &&
                                <div style={{
                                    width: '100%',
                                    minHeight: this.state.mainHeight,
                                    textAlign: 'center',
                                    position: 'relative',
                                }}>
                                    <img style={{
                                        width: '200px',
                                        height: '200px',
                                        position: 'absolute',
                                        top: '28px',
                                        left: '50%',
                                        marginLeft: '-100px',
                                    }} src={require('../../assets/images/null.png')} alt=""/>
                                    <p style={{
                                        width: '100%',
                                        height: '274px',
                                        paddingTop: '250px',
                                        textAlign: 'center',
                                        lineHeight: '24px',
                                        fontSize: '18px',
                                        color: '#999',
                                    }}>暂无数据</p>
                                </div>
                            }
                        </Spin>
                    </Content>
                </Layout>
            </Layout>
        </div>;
    }
}
;
export default withRouter(MallHome);



// WEBPACK FOOTER //
// ./src/mall/mallHome/index.js